

































































import Component, {mixins} from 'vue-class-component';
import {State} from 'vuex-class';
import Pagination, {PaginationInput} from '@/modules/core/model/pagination';
import Session from '@/modules/user/model/Session';
import {Prop, Watch} from 'vue-property-decorator';
import {notify} from '@/modules/core/notification';
import {DateMixin} from '@/modules/core/date';
import {VDataTableOptions} from '@/types';
import {DeleteSessionsCriteria} from '@/modules/user/api';

/**
 * Lista de sesiones
 *
 * @author Alejandro G. Riaño <agutierrez@oftcontrol.es>
 */
@Component
export default class SessionList extends mixins(DateMixin) {
    /**
     * Paginación de sesiones mostrada actualmente al usuario
     */
    @State(state => state.user.sessionsPagination)
    public pagination: Pagination<Session>

    /**
     * Id del usuario por el cual filtrar la lista de reservas
     */
    @Prop({type: Number, default: 0})
    public user: number

    public loading = false

    /**
     * Define el alto de la tabla
     */
    @Prop({type: String, default: ''})
    public height: string

    public selected: Session[] = []
    public confirmDeleteSessions = false
    public deletingSessions = false

    public deleteSessionsCriteria: DeleteSessionsCriteria = {
        user: 0,
        ids: [],
    }

    public headers = [
        { text: 'Id', value: 'id', width: '70px', sortable: false},
        { text: 'Token', value: 'token', width: '80px', sortable: false},
        { text: 'Estado', value: 'open', sortable: false},
        { text: 'Fecha de creación', value: 'createdAt', sortable: false},
    ]


    public setSelection (select: Session[]) {
        this.selected = select
        this.deleteSessionsCriteria.ids = select.map(s => s.id)
        this.$emit('input', select)
    }

    public async deleteSessions () {
        this.deletingSessions = true
        const { deletedSessions } = await this.$store.dispatch('user/deleteSessions', this.deleteSessionsCriteria)

        this.deletingSessions = false
        this.confirmDeleteSessions = false
        this.deleteSessionsCriteria.ids = []
        this.loadPagination()

        notify(`Se han eliminado correctamente ${ deletedSessions } sesiones`)
    }

    public async copyToClipboard (text: string) {
        if (!navigator.clipboard) {
            return
        }

        await navigator.clipboard.writeText(text)
        notify('Token copiado al portapapeles')
    }

    /**
     * Filtros para configurar la paginación
     */
    public input: PaginationInput<{user: number | undefined}> = {
        page: 1,
        recordsPerPage: 20,
        filters: {
            user: 0,
        },
    }

    @Watch('user', {immediate: true})
    public async onUser (user: number) {
        this.input.filters!.user = user
        await this.loadPagination()
    }

    public updateTable (options: VDataTableOptions) {
        Object.assign(this.input, {
            page: options.page,
            recordsPerPage: options.itemsPerPage,
        })

        this.loadPagination()
    }

    public async loadPagination () {
        this.loading = true
        await this.$store.dispatch('user/loadSessionPagination', this.input)

        this.loading = false
    }
}
